import { combineReducers } from 'redux';
import { SET_TAGS } from '../../../constants/tags';
import {
  createAllIdsTypeReducer,
  createEntityMapTypeReducer,
} from '../../../helpers/reducerCreator';

export default combineReducers({
  allIds: createAllIdsTypeReducer(SET_TAGS, []),
  byId: createEntityMapTypeReducer(SET_TAGS, {}),
});
